import { execAdmin } from '@src/apis/reware/utils';

export interface BatchDeletePricingRulesArgs {
  partnerId: number;
  ruleIds: number[];
}

interface BatchDeletePricingRulesExecVariables {
  partnerId: number;
  ruleIds: number[];
}

interface BatchDeletePricingRulesExecResponse {
  partner: {
    batchDeletePricingRules: {
      deleted: number;
    };
  };
}

/**
 * Batch delete pricing rules by IDs.
 * More efficient than deleting one at a time.
 */
export const batchDeletePricingRules = async ({
  partnerId,
  ruleIds,
}: BatchDeletePricingRulesArgs): Promise<{ deleted: number }> => {
  const query = `
    mutation batchDeletePricingRules(
      $partnerId: Int!
      $ruleIds: [Int!]!
    ) {
      partner(id: $partnerId) {
        batchDeletePricingRules(ruleIds: $ruleIds) {
          deleted
        }
      }
    }
  `;

  const data = await execAdmin<BatchDeletePricingRulesExecVariables, BatchDeletePricingRulesExecResponse>(
    query,
    { variables: { partnerId, ruleIds } }
  );

  return data.partner.batchDeletePricingRules;
};
